module.exports = __webpack_public_path__ + "img/copper7.18fffdc2.gif";